import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { useDrawerContext } from "./drawer";

export interface DrawerBodyProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function DrawerBody(props: Readonly<DrawerBodyProps>) {
  const { className, children, ...rest } = props;
  const { open, float } = useDrawerContext();

  return (
    <div
      {...rest}
      className={twMerge(
        clsx("flex flex-col flex-1", {
          "gap-1 p-3": open || float,
          "gap-2 p-2": !open && !float,
        }),
        className
      )}
    >
      {children}
    </div>
  );
}
